export default __webpack_public_path__ + "static/media/prev.35fda7ca.svg";